import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifierSolidIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.4551 15.4551L11.2719 11.2719M11.2719 11.2719C12.4041 10.1397 13.0401 8.60413 13.0401 7.00298C13.0401 5.40182 12.4041 3.86625 11.2719 2.73406C10.1397 1.60188 8.60413 0.96582 7.00298 0.96582C5.40182 0.96582 3.86625 1.60188 2.73406 2.73406C1.60188 3.86625 0.96582 5.40182 0.96582 7.00298C0.96582 8.60413 1.60188 10.1397 2.73406 11.2719C3.86625 12.4041 5.40182 13.0401 7.00298 13.0401C8.60413 13.0401 10.1397 12.4041 11.2719 11.2719Z",
		stroke: "currentColor",
		strokeWidth: 1.93182,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMagnifierSolidIcon;
